export function isDateArray(value: any): value is Date[] {
  return Array.isArray(value) && value.every((item) => item instanceof Date);
}
